import { DAYSOFWEEK } from '../utils/dates';

const DayOfWeekSelector = ({ currentDay, onSelect }) => {
  return (
    <div className="day-selector-container">
      <div className="day-selector-dropdown">
        <select className="day-select" value={currentDay} onChange={(e) => onSelect(e.target.value)}>
          {DAYSOFWEEK.map((day) => (
            <option key={day} value={day}>
              {day}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DayOfWeekSelector;
